export default "__VITE_ASSET__DVp8oBbp__"